import React from 'react';
import { List, ListItem, Tooltip, TooltipToggle } from 'telia-front-react';
import { normalizeId } from '@telia-common-components/shared';
export const TvPackageOfferingCardAdditionalServicesList = (props) => {
    const { additionalServicesFromProps, additionalServices, cardTitle, translate } = props;
    const servicesAsListItems = additionalServices.map((service) => (React.createElement(ListItem, { key: service.id },
        React.createElement(TooltipToggle, { id: normalizeId(`${service.id}-${cardTitle}`) },
            React.createElement("strong", null, `${translate(`tvcomparison.services.${service.title}.label`)}`)),
        React.createElement(Tooltip, { referenceElement: normalizeId(`${service.id}-${cardTitle}`, true) }, `${translate(`tvcomparison.services.${service.title}.description`)}`))));
    const getId = (index) => normalizeId(`${cardTitle}-additionalServiceFromProps-${index}`);
    const serviceToListItem = (service, index) => (React.createElement(ListItem, { key: getId(index) },
        React.createElement(TooltipToggle, { id: getId(index) },
            React.createElement("strong", null, service.title)),
        React.createElement(Tooltip, { referenceElement: `#${getId(index)}` }, service.tooltip)));
    if (additionalServicesFromProps === null || additionalServicesFromProps === void 0 ? void 0 : additionalServicesFromProps.length) {
        additionalServicesFromProps.forEach((serviceToInsert, i) => {
            servicesAsListItems.splice(serviceToInsert.insertAt, 0, serviceToListItem(serviceToInsert, i));
        });
    }
    return React.createElement(List, { type: "unstyled" }, servicesAsListItems);
};
